import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackArrow from '../../assets/svg/arrow-left.svg'
import RightSide from "./newPages/rightSide";
import Carousel from "./newPages/carousel/carousel";


const SignUp: React.FC = () => {
    
    const location = useLocation();
    const history = useHistory();



    return (
        <div className="signIn-mainPage" style={{display: "flex", height: "100%", width: "100%"}}>
            <Carousel />
            <div style={{width: "60%"}}>
                {(location.pathname === '/signin/email-signIn' || location.pathname === '/signup') && 
                <div 
                    onClick={() => history.push('/signin')} 
                    style={{height:"60px", cursor: "pointer", display: "flex", alignItems: "center", marginLeft: "24px", color: "#292D32", fontSize: "18px", fontWeight: 400}} >
                    <img src={BackArrow} alt="back-arrow" style={{height: "13px", width: "17px"}} ></img><span style={{marginLeft: "9px"}}>Back</span>
                </div>}
                <RightSide />
            </div>
        </div>
    );
};

export default SignUp;
